import { FC } from "react";

interface ChatBubbleProps {
  open: boolean;
  unreadCount: number;
  onToggle: () => void;
}

// Positioned above Metronic's own .scrolltop button (bottom: 43px, right: 7px,
// 36px size — see _variables.custom.scss) to avoid visual collision.
const ChatBubble: FC<ChatBubbleProps> = ({ open, unreadCount, onToggle }) => (
  <button
    type="button"
    className="btn btn-primary rounded-circle shadow d-flex align-items-center justify-content-center chat-widget-bubble"
    onClick={onToggle}
    title={open ? "Close chat" : "Chat with the Portal Assistant"}
  >
    {open ? (
      <i className="bi bi-x-lg fs-3" />
    ) : (
      <>
        <i className="bi bi-chat-dots fs-2" />
        {unreadCount > 0 && (
          <span className="badge bg-danger rounded-pill position-absolute top-0 start-100 translate-middle">
            {unreadCount}
          </span>
        )}
      </>
    )}
  </button>
);

export { ChatBubble };
